import {
  Box,
  Typography,
  Link,
  Button,
  AppBar,
  Toolbar,
  ButtonGroup,
} from "@mui/material";

import { useSession } from "@inrupt/solid-ui-react";

function Header({
  handleShowCommonplace,
  handleShowLanding,
  handleShowKnowledgeLists,
  currentView = "landing",
}) {
  const { session } = useSession();
  const isLoggedIn = session?.info?.isLoggedIn ?? false;

  return (
    <Box sx={{ flexGrow: 1 }} className="header">
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            CommonSpace: an immersive commonplace book
          </Typography>

          {isLoggedIn && (
            <Typography
              variant="caption"
              sx={{
                mr: 2,
                opacity: 0.9,
                display: { xs: "none", sm: "inline" },
              }}
            >
              Connected
            </Typography>
          )}

          <ButtonGroup variant="text" aria-label="navigation">
            <Button
              color="inherit"
              onClick={handleShowLanding}
              variant={currentView === "landing" ? "outlined" : "text"}
              sx={{
                ...(currentView === "landing" && {
                  borderColor: "rgba(255,255,255,0.5)",
                  bgcolor: "rgba(255,255,255,0.1)",
                }),
              }}
            >
              Home
            </Button>
            <Button
              color="inherit"
              onClick={handleShowCommonplace}
              variant={currentView === "commonplace" ? "outlined" : "text"}
              sx={{
                ...(currentView === "commonplace" && {
                  borderColor: "rgba(255,255,255,0.5)",
                  bgcolor: "rgba(255,255,255,0.1)",
                }),
              }}
            >
              Visit
            </Button>
            <Button
              color="inherit"
              onClick={handleShowKnowledgeLists}
              variant={currentView === "knowledgeLists" ? "outlined" : "text"}
              sx={{
                ...(currentView === "knowledgeLists" && {
                  borderColor: "rgba(255,255,255,0.5)",
                  bgcolor: "rgba(255,255,255,0.1)",
                }),
              }}
            >
              Personalize
            </Button>
          </ButtonGroup>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default Header;
